module.exports = __webpack_public_path__ + "static/img/gzyh.59d55f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gzyh.png
// module id = hy3w
// module chunks = 0